import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-semibold transition-[background-color,border-color,color,box-shadow,transform] duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background active:translate-y-px disabled:pointer-events-none disabled:translate-y-0 disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "border border-transparent bg-primary text-primary-foreground shadow-sm hover:bg-brand-hover active:bg-brand-active",
        destructive:
          "border border-transparent bg-danger-solid text-destructive-foreground shadow-sm hover:bg-danger-solid/90",
        outline:
          "border border-border-strong bg-surface-card text-content-primary shadow-sm hover:bg-surface-hover",
        secondary:
          "border border-border bg-secondary text-secondary-foreground shadow-sm hover:bg-surface-hover",
        ghost: "text-content-secondary hover:bg-surface-hover hover:text-content-primary",
        link: "h-auto text-primary underline-offset-4 hover:text-brand-hover hover:underline",
      },
      size: {
        default: "h-control px-3.5",
        xs: "h-6 rounded-md px-2 text-[10px]",
        sm: "h-control-sm rounded-md px-3 text-xs",
        lg: "h-control-lg rounded-md px-5",
        icon: "h-control w-[var(--control-height)]",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
